import ProductCard2 from './ProductCard2';
import React, { useState } from 'react';
// Main component to display two products side by side
const ProductsCardOfTwo = ({ product1, product2 }) => {

    return (
        <div className="flex gap-2" style={{ marginBottom: '10px', maxWidth: '100%', backgroundColor: 'transparent' }}>
            <div style={{ width: "50%", marginLeft: '5px' }}>
                <ProductCard2
                    product={product1}
                />
            </div>
            <div style={{ width: "50%", marginRight: '5px' }}>
                <ProductCard2
                    product={product2}
                />
            </div>
        </div>
    );
};

export default ProductsCardOfTwo;